export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f1570a9d64a11f7825e03f7a292d9defe302cd5a6&name=fetchTypeahead!'